import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  tr: {
    translation: {
      // Navigation
      "home": "Ana Sayfa",
      "services": "Hizmetler",
      "about": "Hakkımızda",
      "contact": "İletişim",
      "login": "Giriş Yap",
      "logout": "Çıkış Yap",
      "profile": "Profil",
      
      // HomePage
      "welcome": "Kairoscope\nYapay Zeka Destekli Numeroloji'ye Hoş Geldiniz",
      "subtitle": "Gelişmiş AI Algoritmaları ile Sayıların Gizemli Gücünü Keşfedin",
      "description": "Yapay zeka teknolojisi ile desteklenen profesyonel numeroloji analizleri ile kişisel rehberlik alın.",
      "getStarted": "AI Analizi Başlat",
      "learnMore": "Daha Fazla Bilgi",
      "ourServices": "AI Destekli Hizmetlerimiz",
      "moreInfo": "Daha Fazla",
      
      // Service descriptions
      "personalNumerology": "AI Kişisel Numeroloji",
      "personalNumerologyDesc": "Yapay zeka algoritmaları ile doğum tarihiniz ve isminizden kişisel sayılarınızı keşfedin.",
      "relationshipNumerology": "AI İlişki Numerolojisi", 
      "relationshipNumerologyDesc": "Gelişmiş AI ile iki kişi arasındaki uyumu ve dinamikleri derinlemesine analiz edin.",
      "astroNumerology": "AI Astrolojik Numeroloji",
      "astroNumerologyDesc": "Yapay zeka destekli astrologi ve numeroloji birleşimi ile kapsamlı analiz.",
      "synastry": "AI Sinastri Analizi",
      "synastryDesc": "Yapay zeka ile iki kişinin doğum haritalarının karşılaştırmalı analizi.",
      "futureNumerology": "AI Gelecek Numerolojisi",
      "futureNumerologyDesc": "Gelişmiş AI algoritmaları ile gelecekteki dönemlerinizi ve fırsatlarınızı keşfedin.",
      "financialNumerology": "AI Finansal Numeroloji",
      "financialNumerologyDesc": "Yapay zeka destekli para ve zenginlikle ilgili numerolojik rehberlik.",
      "psychologicalNumerology": "AI Psikolojik Numeroloji",
      "psychologicalNumerologyDesc": "Gelişmiş AI ile iç dünyanızı ve kişiliğinizi derinlemesine analiz edin.",
      "healingNumbers": "AI Sayılarla Şifa",
      "healingNumbersDesc": "Yapay zeka destekli sağlık, enerji merkezleri ve şifa frekansları analizi ile iyileşme yolculuğu.",
      
      // Features
      "whyChooseUs": "Neden AI Destekli Kairoscope'u Tercih Etmelisiniz?",
      "professionalAnalysis": "AI Destekli Profesyonel Analizler",
      "professionalAnalysisDesc": "Gelişmiş yapay zeka algoritmaları ile hazırlanan detaylı ve kişiselleştirilmiş analizler.",
      "personalGuidance": "AI Kişisel Rehberlik",
      "personalGuidanceDesc": "Yapay zeka teknolojisi ile size özel hazırlanan öneriler ve yaşam rehberi.",
      "futureInsight": "AI Gelecek Görüşü",
      "futureInsightDesc": "Gelişmiş makine öğrenmesi ile geleceğe dair öngörüler ve fırsat analizleri.",
      
      // Auth
      "signIn": "Giriş Yap",
      "signUp": "Kayıt Ol",
      "signInWithGoogle": "Google ile Giriş Yap",
      "signInDescription": "AI destekli kişiselleştirilmiş numeroloji analizlerinize erişmek için giriş yapın.",
      
      // Footer
      "quickLinks": "Hızlı Bağlantılar",
      "followUs": "Bizi Takip Edin",
      "footerText": "© 2025 Kairoscope Numeroloji - AI Powered. Made with ❤️ • Tüm hakları saklıdır.",
      "privacyPolicy": "Gizlilik Politikası",
      "termsOfService": "Kullanım Şartları",

      // Personal Numerology Page
      "personalNumerologyTitle": "Kişisel Numeroloji Analizi",
      "personalNumerologySubtitle": "Hayat Yolu Sayısı, Kader Sayısı, Ruh Sayısı gibi temel numerolojik analizlerle kendinizi daha yakından tanıyın. Bu analiz, doğum tarihiniz ve isminize dayanarak kişisel özelliklerinizi, yeteneklerinizi ve hayat amacınızı ortaya çıkaracak.",
      "lifePathNumber": "Hayat Yolu Sayısı",
      "lifePathNumberDesc": "Doğum tarihinizden hesaplanan, hayatınızın genel amacını ve potansiyelini gösteren temel sayı.",
      "destinyNumber": "Kader Sayısı",
      "destinyNumberDesc": "Tam adınızdan hesaplanan, hayattaki misyonunuzu ve karmanızı gösteren sayı.",
      "soulNumber": "Ruh Sayısı",
      "soulNumberDesc": "İsimlerinizdeki sesli harflerden hesaplanan, içsel motivasyonlarınızı ve arzularınızı gösteren sayı.",
      "personalityNumber": "Kişilik Sayısı",
      "personalityNumberDesc": "İsimlerinizdeki sessiz harflerden hesaplanan, dış dünyaya yansıttığınız kişiliği gösteren sayı.",
      "expressionNumber": "İfade Sayısı",
      "expressionNumberDesc": "Tam adınızdan hesaplanan, yeteneklerinizi ve bu hayatta nasıl ifade bulduğunuzu gösteren sayı.",
      "birthdayNumber": "Doğum Günü Sayısı",
      "birthdayNumberDesc": "Doğduğunuz günün sayısı, hayatınızda öne çıkan özellikleri ve yetenekleri gösterir.",
      "fullName": "Adınız Soyadınız",
      "birthDate": "Doğum Tarihi",
      "focusArea": "Odaklanmak İstediğiniz Alan (İsteğe Bağlı)",
      "focusAreaPlaceholder": "Örn: Kariyer, aşk hayatı, kişisel gelişim, sağlık...",
      "analyze": "Analiz Et",
      "analyzing": "Analiz Ediliyor...",

      // Relationship Numerology Page
      "relationshipNumerologyTitle": "İlişki Numerolojisi",
      "relationshipNumerologySubtitle": "İki kişi arasındaki uyumluluk, ilişki dinamikleri ve aile analizleriyle ilişkilerinizin numerolojik uyumunu keşfedin. Bu analiz, iki kişinin isim ve doğum tarihlerine dayanarak aralarındaki enerji akışını, uyumu ve potansiyel zorlukları ortaya çıkaracak.",
      "romanticCompatibility": "Romantik İlişki Uyumu",
      "romanticCompatibilityDesc": "İki kişi arasındaki romantik uyumu, zorlukları ve potansiyel gelişim alanlarını gösterir.",
      "friendshipCompatibility": "Arkadaşlık Uyumu",
      "friendshipCompatibilityDesc": "Arkadaşlar arasındaki enerji akışını, ortak ilgi alanlarını ve iletişim dinamiklerini ortaya çıkarır.",
      "marriageNumerology": "Evlilik Numerolojisi",
      "marriageNumerologyDesc": "Evliliğin karşılıklı büyüme, zorluklar ve uzun vadeli uyum potansiyelini değerlendirir.",
      "familyDynamics": "Aile Dinamikleri",
      "familyDynamicsDesc": "Aile üyeleri arasındaki enerji akışını, roller ve karşılıklı etkileşimleri analiz eder.",
      "businessPartnership": "İş Ortaklığı",
      "businessPartnershipDesc": "İş ortakları arasındaki uyum, tamamlayıcı yetenekler ve potansiyel zorlukları değerlendirir.",
      "parentChildRelationship": "Ebeveyn-Çocuk İlişkisi",
      "parentChildRelationshipDesc": "Ebeveyn ve çocuk arasındaki karşılıklı öğrenme, gelişim ve destek alanlarını analiz eder.",
      "person1Name": "1. Kişinin Adı",
      "person1BirthDate": "1. Kişinin Doğum Tarihi",
      "person2Name": "2. Kişinin Adı",
      "person2BirthDate": "2. Kişinin Doğum Tarihi",
      "relationshipType": "İlişki Türü",
      "relationshipTypePlaceholder": "Romantik ilişki",
      "relationshipAnalysisTitle": "İlişki Uyumu Analizi",
      "relationshipAnalysisSubtitle": "İki kişinin isim ve doğum tarihlerine dayanarak aralarındaki numerolojik uyum analiz edin. Bu analiz, ilişkinizin güçlü yönlerini, zorlukları ve gelişim alanlarını ortaya koyacak.",
      "startAnalysis": "Analizi Başlat",

      // Psychological Numerology Page
      "psychologicalNumerologyTitle": "Psikolojik Numeroloji",
      "psychologicalNumerologySubtitle": "Kişilik tipleri, arketipler ve psikolojik profiller analizleriyle zihin dünyamıza sayıların penceresinden bakın. Bu analiz, doğum tarihiniz ve isminize dayanarak psikolojik yapınızı, bilinçaltı kalıplarınızı ve içsel motivasyonlarınızı ortaya çıkaracak.",
      "personalityType": "Kişilik Tipi",
      "personalityTypeDesc": "Doğum tarihiniz ve isminizden hesaplanan, temel kişilik özelliklerinizi gösteren sayısal karakter tipi.",
      "archetypes": "Arketiplerınız",
      "archetypesDesc": "Bilinçaltınızdaki temel arketipler ve bunların yaşamınızdaki etkilerini gösteren sayılar.",
      "psychologicalChallenges": "Psikolojik Zorluklar",
      "psychologicalChallengesDesc": "Hayatınızda yüzleşmeniz gereken temel psikolojik engeller ve bunları aşma potansiyelinizi gösteren sayılar.",
      "innerMotivation": "İçsel Motivasyon",
      "innerMotivationDesc": "Derinlerdeki motivasyonlarınızı ve hayattaki temel dürtülerinizi açığa çıkaran sayılar.",
      "subconsciousPatterns": "Bilinçaltı Kalıplar",
      "subconsciousPatternsDesc": "Bilinçaltınızdaki düşünce kalıplarını ve davranış şemalarını açığa çıkaran sayısal kodlar.",
      "defensemechanisms": "Savunma Mekanizmaları",
      "defenseMechanismsDesc": "Kendinizi korumak için kullandığınız savunma mekanizmalarını ve bunların kaynaklarını gösteren sayılar.",
      "focusQuestion": "Odaklanmak İstediğiniz Soru (Opsiyonel)",
      "focusQuestionPlaceholder": "Örn: Kariyerimde doğru yolda mıyım? İlişkilerimde neden benzer sorunları yaşıyorum?",
      "psychologicalAnalysisTitle": "Psikolojik Numeroloji Analizi",
      "psychologicalAnalysisSubtitle": "Adınız ve doğum tarihinizden yola çıkarak psikolojik numeroloji analizinizi alın. Bu analiz, kişilik tipinizi, bilinçaltı kalıplarınızı ve içsel dürtülerinizi aydınlatacak.",

      // Astro Numerology Page
      "astroNumerologyTitle": "Astrolojik Numeroloji",
      "astroNumerologySubtitle": "Numeroloji ve astrolojinin birleştiği bu analizde, sayıların ve yıldızların rehberliğiyle kozmik yolculuğunuzu keşfedin. Bu analiz, doğum haritanızın numerolojik karşılıklarını inceleyerek evrenle olan bağlantınızı derinleştirecek.",
      "cosmicNumber": "Kozmik Sayınız",
      "cosmicNumberDesc": "Doğum anınızdaki gezegen konumlarını ve sayısal değerlerini birleştiren, kişisel kozmik haritanızı çıkaran sayı.",
      "moonNumber": "Ay Sayınız",
      "moonNumberDesc": "Doğum anınızdaki Ay konumunun fazının numerolojik karşılığı, duygusal doğanız ve içgüdüsel tepkilerinizi gösterir.",
      "sunNumber": "Güneş Sayınız",
      "sunNumberDesc": "Doğum haritanızdaki Güneş konumunun numerolojik karşılığı, temel benliğinizi ve hayat enerjinizi gösterir.",
      "planetaryInfluences": "Gezegen Etkileri",
      "planetaryInfluencesDesc": "Doğum haritanızdaki gezegenlerin sayısal değerleri ve bunların hayatınızdaki etkileri.",
      "risingNumber": "Yükselen Sayınız",
      "risingNumberDesc": "Doğum anınızdaki yükselen burçun numerolojik karşılığı, dış dünyaya yansıttığınız kişiliği gösterir.",
      "zodiacCompatibility": "Zodyak Uyumu",
      "zodiacCompatibilityDesc": "Burçunuzun sayısal değeri ve numerolojik uyum, doğal eğilimlerinizi ve potansiyelinizi gösterir.",
      "birthTime": "Doğum Saati",
      "birthPlace": "Doğum Yeri",
      "birthPlacePlaceholder": "Şehir, Ülke",
      "astroAnalysisTitle": "Astrolojik Numeroloji Analizi",
      "astroAnalysisSubtitle": "Doğum bilgilerinize dayanarak, astrolojik ve numerolojik analizin birleşimi olan bu özel analizi alın. Gezegensel etkiler ve sayısal vibrasyonlar aracılığıyla kozmik yolculuğunuzu keşfedin.",
      "focusAreaOptional": "Odak Alanı (İsteğe bağlı)",
      "focusAreaPlaceholderAstro": "Hangi konularda rehberlik almak istiyorsunuz? (Kariyer, ilişkiler, sağlık, vb.)",

      // Healing Numbers Page
      "healingNumbersTitle": "Sayılarla Şifa",
      "healingNumbersSubtitle": "Sağlık, enerji merkezleri ve şifa frekansları analizleriyle sayıların iyileştirici gücünü keşfedin. Bu analiz, doğum tarihiniz ve isminize dayanarak sağlık potansiyelinizi ve size özel şifa yöntemlerini ortaya çıkaracak.",
      "healthVibration": "Sağlık Vibrasyonu",
      "healthVibrationDesc": "Genel sağlık potansiyelinizi ve doğal bağışıklık gücünüzü gösteren temel sayı.",
      "energyBalance": "Enerji Denge Sayısı",
      "energyBalanceDesc": "Çakralarınızın ve enerji merkezlerinizin dengesini ve akışını gösteren sayı.",
      "healthChallenges": "Sağlık Zorlukları",
      "healthChallengesDesc": "Hayat boyunca karşılaşabileceğiniz potansiyel sağlık zorluklarını gösteren sayılar.",
      "healingPath": "Şifa Yolu",
      "healingPathDesc": "Sizin için en etkili iyileşme ve şifa yöntemlerini gösteren sayı.",
      "spiritualHealth": "Ruhsal Sağlık",
      "spiritualHealthDesc": "Ruhsal dengeni ve manevi bağlantınızı gösteren sayı.",
      "healingFrequencies": "Şifa Frekansları",
      "healingFrequenciesDesc": "Size özel iyileştirici ses frekanslarını ve titresimleri gösteren sayılar.",
      "healthConcern": "Sağlık Endişeniz (Opsiyonel)",
      "healthConcernPlaceholder": "Varsa, odaklanmak istediğiniz sağlık konusunu belirtin",
      "healingAnalysisTitle": "Sayılarla Şifa Analizi",
      "healingAnalysisSubtitle": "Adınız ve doğum tarihinizden yola çıkarak kişisel şifa sayılarınızı analiz edin. Enerji merkezlerinizin dengesi, sağlık potansiyeliniz ve size özel şifa frekanslarını keşfedin.",

      // Profile Page
      "profileTitle": "Profil",
      "profileSubtitle": "Hesap bilgilerinizi yönetin, analiz geçmişinizi görüntüleyin ve ayarlarınızı düzenleyin.",
      "personalInfo": "Kişisel Bilgiler",
      "analysisHistory": "Analiz Geçmişi",
      "settings": "Ayarlar",
      "edit": "Düzenle",
      "cancel": "İptal",
      "save": "Kaydet",
      "saving": "Kaydediliyor...",
      "email": "E-posta",
      "phone": "Telefon",
      "location": "Konum",
      "locationPlaceholder": "Şehir, Ülke",
      "aboutMe": "Hakkımda",
      "aboutPlaceholder": "Kendiniz hakkında kısa bir açıklama...",
      "language": "Dil",
      "privacy": "Gizlilik",
      "private": "Özel",
      "public": "Herkese Açık",
      "notifications": "E-posta bildirimleri al",
      "accountActions": "Hesap İşlemleri",
      "deleteAccount": "Hesabı Sil",
      "downloadAll": "Tümünü İndir",
      "view": "Görüntüle",
      "download": "İndir",

      // Common
      "user": "Kullanıcı",
      "namePlaceholder": "Tam ad",
      "emailPlaceholder": "E-posta adresiniz",
      "phonePlaceholder": "Telefon numaranız",
      "pleaseCompleteRequiredFields": "Lütfen gerekli alanları doldurun",
      "analysisError": "Analiz sırasında bir hata oluştu. Lütfen tekrar deneyin."
    }
  },
  en: {
    translation: {
      // Navigation
      "home": "Home",
      "services": "Services",
      "about": "About",
      "contact": "Contact",
      "login": "Login",
      "logout": "Logout",
      "profile": "Profile",
      
      // HomePage
      "welcome": "Kairoscope\nAI-Powered Numerology Welcome",
      "subtitle": "Discover the Mystical Power of Numbers with Advanced AI Algorithms",
      "description": "Get personalized guidance with professional numerology analyses powered by artificial intelligence technology.",
      "getStarted": "Start AI Analysis",
      "learnMore": "Learn More",
      "ourServices": "Our AI-Powered Services",
      "moreInfo": "More Info",
      
      // Service descriptions
      "personalNumerology": "AI Personal Numerology",
      "personalNumerologyDesc": "Discover your personal numbers with AI algorithms analyzing your birth date and name.",
      "relationshipNumerology": "AI Relationship Numerology",
      "relationshipNumerologyDesc": "Deep analysis of compatibility and dynamics between two people with advanced AI.",
      "astroNumerology": "AI Astrological Numerology",
      "astroNumerologyDesc": "Comprehensive analysis combining astrology and numerology with AI assistance.",
      "synastry": "AI Synastry Analysis",
      "synastryDesc": "AI-powered comparative analysis of two people's birth charts.",
      "futureNumerology": "AI Future Numerology",
      "futureNumerologyDesc": "Discover your future periods and opportunities with advanced AI algorithms.",
      "financialNumerology": "AI Financial Numerology",
      "financialNumerologyDesc": "AI-powered numerological guidance related to money and wealth.",
      "psychologicalNumerology": "AI Psychological Numerology",
      "psychologicalNumerologyDesc": "Deep analysis of your inner world and personality with advanced AI.",
      "healingNumbers": "AI Healing with Numbers", 
      "healingNumbersDesc": "AI-powered health, energy centers and healing frequencies analysis for your recovery journey.",
      
      // Features
      "whyChooseUs": "Why Choose AI-Powered Kairoscope?",
      "professionalAnalysis": "AI-Enhanced Professional Analysis",
      "professionalAnalysisDesc": "Detailed and personalized analyses prepared with advanced artificial intelligence algorithms.",
      "personalGuidance": "AI Personal Guidance",
      "personalGuidanceDesc": "Customized recommendations and life guidance powered by AI technology.",
      "futureInsight": "AI Future Insight",
      "futureInsightDesc": "Future predictions and opportunity analyses with advanced machine learning.",
      
      // Auth
      "signIn": "Sign In",
      "signUp": "Sign Up",
      "signInWithGoogle": "Sign In with Google",
      "signInDescription": "Sign in to access your AI-powered personalized numerology analyses.",
      
      // Footer
      "quickLinks": "Quick Links",
      "followUs": "Follow Us",
      "footerText": "© 2025 Kairoscope Numerology - AI Powered. Made with ❤️ • All rights reserved.",
      "privacyPolicy": "Privacy Policy",
      "termsOfService": "Terms of Service",

      // Personal Numerology Page
      "personalNumerologyTitle": "Personal Numerology Analysis",
      "personalNumerologySubtitle": "Get to know yourself better with fundamental numerological analyses like Life Path Number, Destiny Number, Soul Number. This analysis will reveal your personal characteristics, talents, and life purpose based on your birth date and name.",
      "lifePathNumber": "Life Path Number",
      "lifePathNumberDesc": "The fundamental number calculated from your birth date, showing your life's general purpose and potential.",
      "destinyNumber": "Destiny Number",
      "destinyNumberDesc": "The number calculated from your full name, showing your life mission and karma.",
      "soulNumber": "Soul Number",
      "soulNumberDesc": "The number calculated from vowels in your name, showing your inner motivations and desires.",
      "personalityNumber": "Personality Number",
      "personalityNumberDesc": "The number calculated from consonants in your name, showing the personality you project to the world.",
      "expressionNumber": "Expression Number",
      "expressionNumberDesc": "The number calculated from your full name, showing your talents and how you express yourself in this life.",
      "birthdayNumber": "Birthday Number",
      "birthdayNumberDesc": "The number of the day you were born, showing prominent characteristics and talents in your life.",
      "fullName": "Full Name",
      "birthDate": "Birth Date",
      "focusArea": "Focus Area (Optional)",
      "focusAreaPlaceholder": "E.g.: Career, love life, personal development, health...",
      "analyze": "Analyze",
      "analyzing": "Analyzing...",

      // Relationship Numerology Page
      "relationshipNumerologyTitle": "Relationship Numerology",
      "relationshipNumerologySubtitle": "Discover the numerological compatibility of your relationships through compatibility analysis, relationship dynamics, and family analyses between two people. This analysis will reveal the energy flow, harmony, and potential challenges between two people based on their names and birth dates.",
      "romanticCompatibility": "Romantic Relationship Compatibility",
      "romanticCompatibilityDesc": "Shows romantic compatibility, challenges, and potential growth areas between two people.",
      "friendshipCompatibility": "Friendship Compatibility",
      "friendshipCompatibilityDesc": "Reveals energy flow, common interests, and communication dynamics between friends.",
      "marriageNumerology": "Marriage Numerology",
      "marriageNumerologyDesc": "Evaluates marriage's mutual growth, challenges, and long-term compatibility potential.",
      "familyDynamics": "Family Dynamics",
      "familyDynamicsDesc": "Analyzes energy flow, roles, and mutual interactions between family members.",
      "businessPartnership": "Business Partnership",
      "businessPartnershipDesc": "Evaluates compatibility, complementary skills, and potential challenges between business partners.",
      "parentChildRelationship": "Parent-Child Relationship",
      "parentChildRelationshipDesc": "Analyzes mutual learning, development, and support areas between parent and child.",
      "person1Name": "Person 1 Name",
      "person1BirthDate": "Person 1 Birth Date",
      "person2Name": "Person 2 Name",
      "person2BirthDate": "Person 2 Birth Date",
      "relationshipType": "Relationship Type",
      "relationshipTypePlaceholder": "Romantic relationship",
      "relationshipAnalysisTitle": "Relationship Compatibility Analysis",
      "relationshipAnalysisSubtitle": "Analyze the numerological compatibility between two people based on their names and birth dates. This analysis will reveal the strengths, challenges, and growth areas of your relationship.",
      "startAnalysis": "Start Analysis",

      // Psychological Numerology Page
      "psychologicalNumerologyTitle": "Psychological Numerology",
      "psychologicalNumerologySubtitle": "Look at our mental world through the lens of numbers with personality types, archetypes, and psychological profile analyses. This analysis will reveal your psychological structure, subconscious patterns, and inner motivations based on your birth date and name.",
      "personalityType": "Personality Type",
      "personalityTypeDesc": "The numerical character type calculated from your birth date and name, showing your fundamental personality traits.",
      "archetypes": "Your Archetypes",
      "archetypesDesc": "The fundamental archetypes in your subconscious and numbers showing their effects on your life.",
      "psychologicalChallenges": "Psychological Challenges",
      "psychologicalChallengesDesc": "Numbers showing the fundamental psychological obstacles you need to face in life and your potential to overcome them.",
      "innerMotivation": "Inner Motivation",
      "innerMotivationDesc": "Numbers revealing your deep motivations and fundamental drives in life.",
      "subconsciousPatterns": "Subconscious Patterns",
      "subconsciousPatternsDesc": "Numerical codes revealing thought patterns and behavioral schemas in your subconscious.",
      "defensemechanisms": "Defense Mechanisms",
      "defenseMechanismsDesc": "Numbers showing the defense mechanisms you use to protect yourself and their sources.",
      "focusQuestion": "Focus Question (Optional)",
      "focusQuestionPlaceholder": "E.g.: Am I on the right path in my career? Why do I experience similar problems in my relationships?",
      "psychologicalAnalysisTitle": "Psychological Numerology Analysis",
      "psychologicalAnalysisSubtitle": "Get your psychological numerology analysis based on your name and birth date. This analysis will illuminate your personality type, subconscious patterns, and inner drives.",

      // Astro Numerology Page
      "astroNumerologyTitle": "Astrological Numerology",
      "astroNumerologySubtitle": "In this analysis where numerology and astrology combine, discover your cosmic journey with the guidance of numbers and stars. This analysis will deepen your connection with the universe by examining the numerological correspondences of your birth chart.",
      "cosmicNumber": "Your Cosmic Number",
      "cosmicNumberDesc": "The number that combines planetary positions and numerical values at your birth moment, creating your personal cosmic map.",
      "moonNumber": "Your Moon Number",
      "moonNumberDesc": "The numerological correspondence of the Moon's phase position at your birth moment, showing your emotional nature and instinctive reactions.",
      "sunNumber": "Your Sun Number",
      "sunNumberDesc": "The numerological correspondence of the Sun's position in your birth chart, showing your fundamental self and life energy.",
      "planetaryInfluences": "Planetary Influences",
      "planetaryInfluencesDesc": "The numerical values of planets in your birth chart and their effects on your life.",
      "risingNumber": "Your Rising Number",
      "risingNumberDesc": "The numerological correspondence of the rising sign at your birth moment, showing the personality you project to the outside world.",
      "zodiacCompatibility": "Zodiac Compatibility",
      "zodiacCompatibilityDesc": "The numerical value of your zodiac sign and numerological compatibility, showing your natural tendencies and potential.",
      "birthTime": "Birth Time",
      "birthPlace": "Birth Place",
      "birthPlacePlaceholder": "City, Country",
      "astroAnalysisTitle": "Astrological Numerology Analysis",
      "astroAnalysisSubtitle": "Get this special analysis that combines astrological and numerological analysis based on your birth information. Discover your cosmic journey through planetary influences and numerical vibrations.",
      "focusAreaOptional": "Focus Area (Optional)",
      "focusAreaPlaceholderAstro": "Which topics would you like guidance on? (Career, relationships, health, etc.)",

      // Healing Numbers Page
      "healingNumbersTitle": "Healing with Numbers",
      "healingNumbersSubtitle": "Discover the healing power of numbers through health, energy centers, and healing frequency analyses. This analysis will reveal your health potential and personalized healing methods based on your birth date and name.",
      "healthVibration": "Health Vibration",
      "healthVibrationDesc": "The fundamental number showing your general health potential and natural immunity strength.",
      "energyBalance": "Energy Balance Number",
      "energyBalanceDesc": "The number showing the balance and flow of your chakras and energy centers.",
      "healthChallenges": "Health Challenges",
      "healthChallengesDesc": "Numbers showing potential health challenges you may encounter throughout life.",
      "healingPath": "Healing Path",
      "healingPathDesc": "The number showing the most effective healing and recovery methods for you.",
      "spiritualHealth": "Spiritual Health",
      "spiritualHealthDesc": "The number showing your spiritual balance and spiritual connection.",
      "healingFrequencies": "Healing Frequencies",
      "healingFrequenciesDesc": "Numbers showing healing sound frequencies and vibrations specific to you.",
      "healthConcern": "Health Concern (Optional)",
      "healthConcernPlaceholder": "If any, specify the health topic you want to focus on",
      "healingAnalysisTitle": "Healing with Numbers Analysis",
      "healingAnalysisSubtitle": "Analyze your personal healing numbers based on your name and birth date. Discover the balance of your energy centers, your health potential, and healing frequencies specific to you.",

      // Profile Page
      "profileTitle": "Profile",
      "profileSubtitle": "Manage your account information, view your analysis history, and edit your settings.",
      "personalInfo": "Personal Information",
      "analysisHistory": "Analysis History",
      "settings": "Settings",
      "edit": "Edit",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving...",
      "email": "Email",
      "phone": "Phone",
      "location": "Location",
      "locationPlaceholder": "City, Country",
      "aboutMe": "About",
      "aboutPlaceholder": "A brief description about yourself...",
      "language": "Language",
      "privacy": "Privacy",
      "private": "Private",
      "public": "Public",
      "notifications": "Receive email notifications",
      "accountActions": "Account Actions",
      "deleteAccount": "Delete Account",
      "downloadAll": "Download All",
      "view": "View",
      "download": "Download",

      // Common
      "user": "User",
      "namePlaceholder": "Full name",
      "emailPlaceholder": "Your email address",
      "phonePlaceholder": "Your phone number",
      "pleaseCompleteRequiredFields": "Please complete the required fields",
      "analysisError": "An error occurred during analysis. Please try again."
    }
  }
};

// Get saved language from localStorage or default to Turkish
const savedLanguage = localStorage.getItem('language') || 'tr';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 